import React, { useState } from 'react'
import { Alert, Button, Col, Container, Row } from 'react-bootstrap'
import ExamenDiagnosticoLecturaVeloz from './ExamenDiagnosticoLecturaVeloz'
import TitleDashboard from '@components/general/Titles/TitleDashboard';
import Swal from 'sweetalert2';
import { Notificacion } from '@components/general/Alertas/Alertas';
import { Warning } from '@mui/icons-material';

const FormExamenDiagnostico = ({setRealizarExamenDiagnostico, semanaAvance, handleScrollToTop}) => {

    const [mostrarResultadosEvaluacion, setMostrarResultadosEvaluacion] = useState(false);
    

    //Logica para mostrar los componenetes del diagnostico:
    /**
     * Instructivo de la evaluacion
     * Se muestra el componente de examen diagnostico para comenzar con la evaluacion.
     * Dentro del componente de examen se evaluará y se harán los ajustes en el progreso al usuario que se esté evaluando
     * 
     * *Se Podrá resetear todo el progreso no sin antes recomendarselo al estudiante, además de que se podrá mantener el progreso actual en el curso una vez que comprueba que cumple con las condiciones.
     */

    const [realizarExamen, setRealizarExamen] = useState(false);

    const handleHacerEvaluacion = () => {
        setRealizarExamen(true);
    }

    const regresar = async() => {

        const { isConfirmed } = await Swal.fire({
            title: "¿Seguro que quieres salir?",
            text: "Estás a punto regresar, tendrás que comenzar la evaluación de nuevo",
            showCancelButton: true,
            reverseButtons: true,
            confirmButtonText: "Entendido",
            cancelButtonText: "Cancelar",
            confirmButtonColor: "#0d6efd",
            allowOutsideClick: false,
        });

        if (!isConfirmed) {

            return Notificacion("info", "Puedes continuar con tu evaluación");
        }

        setRealizarExamenDiagnostico(false);


    }

  return (
    <>
    <Row className="mt-5 mx-2 mb-5 justify-content-around">
        <Col className="text-start col-12 col-md-auto">
            <TitleDashboard title={"Exámen diagnóstico"}/>
        </Col>

        {!mostrarResultadosEvaluacion ? (
             <Col className="text-start col-12 col-md-auto mt-3 mt-md-0">
                <Button onClick={regresar} className='btn-danger'>Regresar</Button>
            </Col>
        ): null}
    </Row>


    {/* Componente dividido en varias etapas: instructivo, lectura, evaluacion, resultados y ajuste de avance */}

    {realizarExamen ? (
        <Row className="p-0">
            <Col className="text-center">
                <ExamenDiagnosticoLecturaVeloz mostrarResultadosEvaluacion={mostrarResultadosEvaluacion} setMostrarResultadosEvaluacion={setMostrarResultadosEvaluacion} handleScrollToTop={handleScrollToTop} setRealizarExamenDiagnostico={setRealizarExamenDiagnostico} semanaAvance={semanaAvance} />
            </Col>
        </Row>
    ) : (
        <Row className="px-0 pb-5 justify-content-center mb-5">
            <Col lg={8} className="text-center p-4 rounded" style={{ backgroundColor: "#dcfcca", fontSize: '14px' }}>

                <h3><strong>Instrucciones de la evaluación</strong></h3>

                <span className='mt-4'>
                    Bienvenido(a) a la evaluación diagnóstica del programa Lectura Inteligente.

                    Esta evaluación tiene como propósito conocer tu velocidad de lectura, medida en palabras por minuto, así como tu nivel actual de comprensión lectora. Con esta información podremos brindarte un acompañamiento adecuado y asegurar que tu aprendizaje avance de acuerdo con tus habilidades reales.

                    La realización de esta prueba es obligatoria, ya que se han identificado registros de progreso inusuales en algunos casos y es importante confirmar que todos los avances reflejen un desempeño auténtico.
                </span>


                <div className='text-start my-4'>
                    <span>Una vez concluida la evaluación, se determinará una de las siguientes acciones:</span>
                    <ul>
                        <li>Ajustar tu progreso dentro del curso, reiniciándolo en el nivel que mejor se adapte a tu resultado actual.</li>
                        <li>Conservar tu avance, permitiéndote continuar con el curso sin cambios.</li>
                    </ul>
                </div>

                <span>Tu participación responsable es fundamental para que el programa cumpla su objetivo de ayudarte a mejorar tu lectura y comprensión de manera efectiva.</span>

                <div>
                    <Button onClick={handleHacerEvaluacion} className="btn btn-primary mt-4">Comenzar evaluación</Button>
                </div>
            </Col>

            <Col className='mb-5 mt-3 p-0' lg={8}>
                <Alert variant='warning'>
                    <p style={{ fontSize: "14px" }} className="text-success text-center">
                        <span className='text-danger'><Warning /></span> <span className="text-dark">Al concluir tu evaluación, no será posible repetirla. Cualquier ajuste que se realice después de su revisión será permanente.</span>
                    </p>

                </Alert>
            </Col>
            {/* <Col className='col-12 text-center mt-5'>
                <Button onClick={handleHacerEvaluacion} className="btn btn-primary">Comenzar evaluación</Button>
            </Col> */}
        </Row>
    )}

   
    </>
  )
}

export default FormExamenDiagnostico